import React, { useEffect } from 'react';
import AICampaignCreation from '../../components/chat/AiCampaignCreation';
import { useAuth } from '../../components/context/AuthContext';
import { useAdsModal } from 'components/context/ModalsContext';
import { useCanCreateCampaign } from 'hooks/useCanCreateCampaign';

const CampaignCreation = () => {
  const { hasGoogleAdsConnected, hasMetaConnected } = useAuth();
  const { openNoAdsConnectedModal, openUpdateBusinessDataModal } = useAdsModal();
  const { canCreateCampaign } = useCanCreateCampaign();

  useEffect(() => {
    if (!hasGoogleAdsConnected && !hasMetaConnected) {
      openNoAdsConnectedModal();
    } else if (!canCreateCampaign) {
      openUpdateBusinessDataModal();
    }
  }, [hasGoogleAdsConnected, hasMetaConnected, canCreateCampaign, openNoAdsConnectedModal, openUpdateBusinessDataModal]);

  return (
    <div className="flex flex-col h-full relative">
      <div className="flex-1 overflow-hidden">
        <div className="h-full">
          <AICampaignCreation />
        </div>
      </div>
    </div>
  );
};

export default CampaignCreation;